import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const PageBody = ({
  children,
  disablePadding,
  width,
}) => (
  <Box
    sx={[{ width: width || '100%' }, disablePadding
      ? { p: '0' }
      : { p: '1rem' }]}
  >
    {children}
  </Box>
)

PageBody.propTypes = {
  children: PropTypes.any,
  disablePadding: PropTypes.bool,
  width: PropTypes.string,
};

PageBody.defaultProps = {
  children: null,
  disablePadding: false,
  width: null,
};

export default PageBody;
